export const environment = {
	production: true,
	baseUrl: 'https://painelcontroleexterno.sistemaindustria.com.br/api-painelcontroleexterno/',
	nome: 'ambiente',
};
